module.exports = __webpack_public_path__ + "static/media/Ripple.7cc6be02.gif";